var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showChip())?_c('v-chip',{attrs:{"outlined":"","small":""}},[_vm._v(" "+_vm._s(_vm.templateLabel)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }